import WrapChar from '@/utils/wrap-char.js'

const charClassName = 'char'
const selectedClassName = 'char-selected'

function update (el, binding) {
    if (!el._onSelectText) return
    el._onSelectText.tempData.model = binding.value || []
    highlight(el._onSelectText.tempData.model, el._onSelectText.tempData.chars)
}

function inserted (el, binding, vNode) {
    let disabled = true

    if (typeof binding.value !== 'object') {
        vNode.context.$emit('input', [])
        // binding.value = []
    }

    let tempData = {
        chars: [],
        startIndex: null,
        finishIndex: null,
        model: binding.value || [],
        updateModelValue (value) {
            vNode.context.$emit('input', value)
        }
    }

    el.style['user-select'] = 'none'
    el.style['-webkit-user-select'] = 'none'
    el.style['-moz-user-select'] = 'none'
    el.style['-ms-user-select'] = 'none'

    //Обворачиваем символы в span
    WrapChar(el)

    el._onSelectText = {
        tempData,
        events: {
            mousemove: (event) => {
                if (!disabled) checkSelect(event, tempData)
            },
            mouseup: () => {
                tempData.updateModelValue(optimizeModel(tempData.chars))

                disabled = true
                tempData.startIndex = null
                tempData.finishIndex = null
            },
            mousedown: (event) => {
                disabled = false
                tempData.chars = getCharsBySelector('.' + charClassName, el)
                checkSelect(event, tempData)
            }
        }
    }

    document.addEventListener('mousedown', el._onSelectText.events.mousedown)
    document.addEventListener('mouseup', el._onSelectText.events.mouseup)
    el.addEventListener('mousemove', el._onSelectText.events.mousemove)
}

function checkSelect (event, tempData) {
    if (!event.target.classList.contains(charClassName)) return

    if (typeof tempData.startIndex !== 'number') {
        tempData.startIndex = getCharIndex(event.target, tempData.chars)
    }
    tempData.finishIndex = getCharIndex(event.target, tempData.chars)

    let capture = getCapture(tempData.startIndex, tempData.finishIndex, tempData.chars)
    if (capture) {
        highlight([...tempData.model, capture], tempData.chars)
    }
}

function getCharsBySelector (selector, el = document) {
    return Array.prototype.slice.apply(el.querySelectorAll(selector))
}

function getCharIndex (char, allChars) {
    return allChars.findIndex(item => item === char)
}

function optimizeModel (chars) {
    let model = []
    let start = null
    let finish = null

    chars.forEach((item, index) => {
        if (item.classList.contains(selectedClassName)) {
            if (typeof start !== 'number') {
                start = index
                finish = index
            } else {
                finish = index
            }
        } else if (typeof start == 'number' && typeof finish == 'number') {
            let fragment = chars.slice(start, finish + 1)
            let text = getTextByFragment(fragment)
            model.push({fragment,text})
            start = null
            finish = null
        }
    })

    return model
}

function highlight (model = []) {
    resetHighlight()
    model.forEach(item => {
        if (!item) return
        item.fragment.forEach(char => {
            char.classList.add(selectedClassName)
        })
    })
}

function resetHighlight() {
    let chars = getCharsBySelector('.' + selectedClassName)
    chars.forEach(char => char.classList.remove(selectedClassName))
}

function getCapture (start, finish, all) {
    if (typeof start !== 'number' || typeof finish !== 'number') return

    let startIndex = Math.min(start, finish)
    let finishIndex = Math.max(start, finish)
    let fragment = all.slice(startIndex, finishIndex + 1)
    let text = getTextByFragment(fragment)

    return {
        fragment,
        text
    }
}

function getTextByFragment (range) {
    return range.map(item => item.innerText || ' ').join('').replace(/\s{2,}/g, ' ')
}

function unbind (el) {
    if (!el._onSelectText) return

    document.addEventListener('mousedown', el._onSelectText.events.mousedown)
    document.addEventListener('mouseup', el._onSelectText.events.mouseup)
    el.addEventListener('mousemove', el._onSelectText.events.mousemove)

    delete el._onSelectText
}

export default {
    name: 'select-text',
    inserted,
    unbind,
    update
}
